import { render, staticRenderFns } from "./Reasons.vue?vue&type=template&id=5afd0a30&scoped=true"
import script from "./Reasons.vue?vue&type=script&lang=js"
export * from "./Reasons.vue?vue&type=script&lang=js"
import style0 from "./Reasons.vue?vue&type=style&index=0&id=5afd0a30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afd0a30",
  null
  
)

export default component.exports